import script from "./PopupView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupView.vue?vue&type=script&setup=true&lang=ts"

import "./PopupView.vue?vue&type=style&index=0&id=48f942f3&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f942f3"]])

export default __exports__